<section class="nhsuk-grid-row app-width">
  <h2 class="nhsuk-heading-xl">Notifications</h2>

  <div class="nhsuk-form-group">
    <ul>
      @for (notification of notifications$ | async; track $index; let i = $index) {
        <li id="card">
          <div class="nhsuk-form-group">
            <label class="nhsuk-label" for="notification-{{ i }}">
              Notification type:
              <span
                ><strong>{{ notification.type.toUpperCase() }}</strong></span
              >
            </label>
            <textarea
              class="nhsuk-textarea"
              id="notification-{{ i }}"
              name="notification-{{ i }}"
              rows="5"
              [value]="notification.message"
              [readonly]="isDefaultType(notification.type)"
              [class.readonly-textarea]="isDefaultType(notification.type)"
            ></textarea>

            <div class="flex space-between">
              <div
                role="switch"
                [attr.aria-checked]="notifications[i].show"
                tabindex="0"
                (click)="toggleNotification(i)"
                (keydown)="handleKeyEvent($event, i)"
              >
                <span class="label">Notifications</span>
                <span class="switch">
                  <span></span>
                </span>
                <span class="on" aria-hidden="true">On</span>
                <span class="off" aria-hidden="true">Off</span>
              </div>
              <div
                role="switch"
                [attr.aria-checked]="notifications[i].showDataStatus"
                tabindex="0"
                (click)="toggleDataStatus(i)"
                (keydown)="handleKeyEvent($event, i)"
              >
                <span class="label">Data Status</span>
                <span class="switch">
                  <span></span>
                </span>
                <span class="on" aria-hidden="true">On</span>
                <span class="off" aria-hidden="true">Off</span>
              </div>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
</section>
